import { useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
import { titlePrefix, titleSuffix } from "utils/BuildUrl/buildTitleAnnonce";

import ListingPagesHepler from "pagesHelpers/ListingPagesHepler/ListingPagesHelper";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useRef, useState } from "react";
export const fix_type = (searchPayload) => {
  return [
    `${
      typeof searchPayload.type == "string"
        ? searchPayload.type == "Appartement"
          ? searchPayload.typologie.length
            ? searchPayload.typologie.length == 1
              ? searchPayload.typologie[0] == 0
                ? "Studio"
                : searchPayload.type
              : searchPayload.type
            : searchPayload.type
          : searchPayload.type
        : searchPayload.type.length
        ? searchPayload.type.length == 1
          ? searchPayload.type[0] == "Appartement"
            ? searchPayload.typologie.length
              ? searchPayload.typologie.length == 1
                ? searchPayload.typologie[0] == 0
                  ? "Studio"
                  : searchPayload.type
                : searchPayload.type
              : searchPayload.type
            : searchPayload.type
          : searchPayload.type
        : searchPayload.type
    }`,
  ];
};

export default function ListingPagesHeplerWrapper({
  transaction_type,
  url,
  isError,
  articleData,
}: {
  transaction_type: "Vente" | "Location" | "Projets Neufs" | "";
  url?: string;
  isError?: boolean;
  articleData?: any;
}) {
  const searchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  let totalItems: any = useSelector(
    ListingreducerSelectors.totalListingsCountSelactor
  );
  const listings: any = useSelector(ListingreducerSelectors.listingsSelector);
  const currentListing: any = useSelector(
    ListingreducerSelectors.currentListingSelactor
  );
  const [error404, setError404] = useState(isError);
  const firstUpdate = useRef(true);
  const firstUpdate2 = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else if (firstUpdate2.current) {
      firstUpdate2.current = false;
      return;
    } else {
      setError404(false);
    }
  }, [searchPayload]);

  let region = searchPayload.region;
  let province = searchPayload.province;
  let commune = searchPayload.commune;
  let quartier = searchPayload.quartier;
  let address = searchPayload.address;

  let page = searchPayload.page;
  let bienType = searchPayload.type.length ? searchPayload.type[0] : null;
  const titleComplement: any = useSelector(
    ListingreducerSelectors.titleComplementSelector
  );
  const { t } = useTranslation("annonceAchat");
  const t2 = useTranslation("villesprovincescommunes").t;

  return (
    <>
      <ListingPagesHepler
        title={`${titlePrefix(
          transaction_type,
          fix_type(searchPayload),
          t,
          searchPayload.vendu ? searchPayload.vendu : false,
        )} ${titleSuffix(
          region ? region : null,
          province ? province : null,
          address
            ? address.split(",")[0]
              ? address.split(",")[0]
              : address
            : commune ?? "",
          t,
          quartier ? quartier : null,
          titleComplement ? titleComplement : null,
          searchPayload.address
        )}`}
        region={region ? region : null}
        province={province ? province : null}
        commune={commune ? commune : null}
        quartier={quartier ? quartier : null}
        title_complement={titleComplement ? t(titleComplement) : null}
        currentListing={currentListing}
        annonceSlug={currentListing ? currentListing.slug : ""}
        bienType={bienType}
        initialListings={listings}
        viewType={searchPayload.transaction_type}
        totalItems={totalItems ? totalItems : null}
        page={page}
        url={url?.replace("/location/", "/louer/")}
        isError={error404}
        articleData={articleData}
      />
    </>
  );
}
